// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelCategory-Components-EditModal-css-module__container--d3owZ"};